import {needAuth} from "../instance/Instance";

async function getBulletinboardList(search, pageable) {
    console.log(">> 자료실 조회")


    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;



    try{
        return  await needAuth.post('/bulletinboard?'+pageStr, search);

    }catch (error){
        return error;
    }
}

async function getBulletinboard(id) {
    return await needAuth.get('/bulletinboard/'+id);
}

async function removeBulletinboards(ids) {
    return await needAuth.put('/bulletinboard/delete', ids);
}

async function saveBulletinboard(data,files)
{
    console.log(files)

    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });


    formData.append(
        "bulletinboardRequestDto",
        new Blob([JSON.stringify(data)], { type: "application/json" })
    );
    return await needAuth.post(
        '/bulletinboard/create',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );


    // return await needAuth.post(`/bulletinboard/create`, data);
}

async function updateBulletinboard(bulletinboard) {
    const data = {id: bulletinboard.id, fieldName : "subject", value : bulletinboard.subject}
    await needAuth.put(`/bulletinboard`, data);
    const data2 = {id: bulletinboard.id, fieldName : "content", value : bulletinboard.content}
    return await needAuth.put(`/bulletinboard`, data2);
}

export {getBulletinboardList, saveBulletinboard, updateBulletinboard, removeBulletinboards,getBulletinboard}